export const StatusAtendimento = {
  Nenhum: 0,
  EmAtendimento: 1,
  Cancelado: 2,
  Concluido: 3,
  Chatbot: 4
};

export const DonoAtendimento = {
  Nenhum: 0,
  Dono: 1,
  EmAtendimento: 2,
  AguardandoAtendimento: 3
};

export default StatusAtendimento;
